import React, { Component } from "react";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import SignedIn from "./SignedIn";
import "../style/SignInSignUp.css";
class SignInSignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signIn: true,
      userAuthed: false
    };
    this.toggleUserAuth = this.toggleUserAuth.bind(this);
  }
  toggleUserAuth() {
    this.setState(prevState => {
      return {
        userAuthed: !prevState.userAuthed
      };
    });
  }
  renderSignup() {
    return (
      <div className="sign-in-sign-up">
        <div className="form-button-holder">
          <button
            className={
              this.state.signIn
                ? "btn form-toggle form-toggle-active"
                : "btn form-toggle"
            }
            onClick={() => this.setState({ signIn: true })}
          >
            Sign in
          </button>
          <button
            className={
              this.state.signIn
                ? "btn form-toggle"
                : "btn form-toggle form-toggle-active"
            }
            onClick={() => this.setState({ signIn: false })}
          >
            Sign up
          </button>
        </div>

        <div className="sign-in-form">
          {this.state.signIn && <SignIn userAuthed={this.toggleUserAuth} />}
          {!this.state.signIn && <SignUp />}
        </div>
      </div>
    );
  }
  render() {
    if (!this.state.userAuthed) return this.renderSignup();
    if (this.state.userAuthed) return SignedIn();
  }
}

export default SignInSignUp;



// WEBPACK FOOTER //
// ./src/components/SignInSignUp.js